/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './AccountSelection.scss';

import classnames from 'classnames';
import { func } from 'prop-types';
import React from 'react';
import { array } from 'newrelic/lib/config/formatters';
import { withRouter } from 'react-router-dom';
import { AAMBeaconButton } from 'components/shared/Beacon';

const BrokerageAccountSelection = ({ account, onSelect, currentCusip='' }) => {
  const {
    positions = [],
    accountType = '',
    accountNumber = '',
    accountChecksum = ''
  } = account;
  positions.sort((a,b) => a.name.localeCompare(b.name));
  const accountsToSelect = () => {
    return (
      <div className="account-type" key={`account-list:Brokerage`}>
        <div className="account-type-list">
          {positions?.map((account) => {
            const { name, cusip, ticker } = account;
            const className = classnames('account-selector-account','brokerage-holdings-button');
            return cusip === currentCusip ? null : (
              <AAMBeaconButton variant="tertiary"
                className={className}
                key={cusip}
               onBeaconEventClick={() => (!cusip ? {} : onSelect(cusip, account))}>
                <div className="account-selector-name">
                  <div> {ticker}  </div>
                  <div
                    className={!cusip ? '' : 'brokerage-account-selector-name'}>
                    {name}
                  </div>
                </div>
              </AAMBeaconButton>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div>
      <h2 className="brokerage-header-name brokerage-account-selection-title">
        Select a holding
      </h2>
      <div className="account-selector-description">
        The holdings below are from the {accountType} brokerage account #
        {accountNumber}-{accountChecksum}.
      </div>
      <div>{accountsToSelect()}</div>
    </div>
  );
};

BrokerageAccountSelection.propTypes = {
  positions: array.isRequired,
  onSelect: func.isRequired
};

export default withRouter(BrokerageAccountSelection);
